/**
 * Clears browser-stored data that belongs to the signed-in person, so the next
 * user of a shared machine can't see the previous user's project, branding or
 * saved work.
 *
 * Deliberately KEPT: cookie/storage consent choices and unit / display
 * preferences (units, performance mode, disclaimer verbosity, toolbar layout,
 * canvas default) — these are device preferences, not user data.
 */

/** Exact keys removed on sign-out. */
const USER_SCOPED_KEYS = [
  'currentSavedConfig.v1',      // last opened project + share token
  'report.companyProfiles.v1',  // saved company branding profiles
  'report.titleBlock.v1',       // current title-block / branding values
  'public-compare-presets-v1',  // saved comparison presets
  'projects_view',              // projects list view choice (user scoped)
  'compare-banner-dismissed',
  'configurator_tour_seen',
];

/** Any key starting with one of these prefixes is removed (per-user variants). */
const USER_SCOPED_PREFIXES = [
  'configurator_tour_seen.',
];

const SESSION_SCOPED_KEYS = [
  'ledlogic-custom-panel',
  'ledlogic_session_log_v1',
];

export function clearUserScopedStorage(): void {
  if (typeof window === 'undefined') return;

  try {
    const ls = window.localStorage;
    for (const key of USER_SCOPED_KEYS) ls.removeItem(key);

    const doomed: string[] = [];
    for (let i = 0; i < ls.length; i++) {
      const key = ls.key(i);
      if (key && USER_SCOPED_PREFIXES.some((p) => key.startsWith(p))) doomed.push(key);
    }
    for (const key of doomed) ls.removeItem(key);
  } catch {
    /* private mode / storage blocked */
  }

  try {
    for (const key of SESSION_SCOPED_KEYS) window.sessionStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

export { USER_SCOPED_KEYS };
